settingsMenu = {};

settingsMenu.toggles = [];
settingsMenu.soundActive = true;
settingsMenu.turboModeToggle = { active: false };
settingsMenu.fullScreenOn = false;

settingsMenu.create = function (json) {
  settingsMenu.container = new PIXI.Container();
  return settingsMenu.container;
};

settingsMenu.initialise = function (json, container) {
  resourceManager.get('buttonContainer:buttonBar:settingsMenu:glow').visible = false;
  if (typeof json.fontDefinition === 'undefined') {
    console.log('A font definition was not found for settingsMenu.');
  }

  settingsMenu.container = container;
  settingsMenu.container.visible = false;
};

settingsMenu.onConfig = function (config) {
  settingsMenu.buttons = config.data.uiElements;

  settingsMenu.buttons.btnHome = gdk.hasHomeButton();

  /*
    settingsMenu.buttons.btnSound = true;
    settingsMenu.buttons.btnTurbo = true;
    settingsMenu.buttons.btnHistory = true;
    settingsMenu.buttons.btnFullscreen = true;
    settingsMenu.buttons.btnRules = true;
    settingsMenu.buttons.btnInfo = true;
    */
};

settingsMenu.setup = function () {
  const canEnableSound = settingsMenu.buttons.btnSound.visible;
  const settingsEnabled = settingsMenu.buttons.btnSettings.enabled;
  const shouldHideOptions = !canEnableSound && settingsEnabled;

  var numOptions = 1; // Stake always available
  if (settingsMenu.buttons.btnHome === true) numOptions++;
  if (settingsMenu.buttons.btnSound.visible) numOptions++;
  if (settingsMenu.buttons.btnTurboMode.visible) numOptions++;
  if (settingsMenu.buttons.btnHistory.visible) numOptions++;
  if (settingsMenu.buttons.btnFullscreen.visible) numOptions++;
  if (settingsMenu.buttons.btnRules.visible) numOptions++;
  if (settingsMenu.buttons.btnInfo.visible) numOptions++;

  var buttonYoffset = 92;
  var currentButtonY = 580;

  var json = settingsMenu.container.Props;

  settingsMenu.background = resourceManager.createObject('sprite', 'background', json.FQN, {
    fileName: 'Desktop_UI_Menu/Menu_Bar.png',
    x: 0,
    y: -80,
  });

  settingsMenu.background.interactive = false;
  // var parent = settingsMenu.background.name;

  settingsMenu.buttonsContainer = resourceManager.createObject('container', 'buttonsContainer', json.FQN, {
    x: 0,
    y: -80,
  });

  const parent = settingsMenu.buttonsContainer.name;

  settingsMenu.closeCheckbox = resourceManager.createObject('sprite', 'closeCheckbox', parent, {
    x: 116,
    y: 20,
    fileName: 'Desktop_UI_Menu/Desktop_Close_Button_Small.png',
    anchor: 0.5,
    scale: 1,
  });
  settingsMenu.closeCheckbox.interactive = true;
  settingsMenu.closeCheckbox.setInteractiveCallbacks(settingsMenu.hidePopup, true);

  if (shouldHideOptions) {
    settingsMenu.background.y = 6;
    settingsMenu.background.scale.set(1, 0.85);
    settingsMenu.closeCheckbox.y = 106;
  }

  // Stake button (always available)
  settingsMenu.stakeToggle = settingsMenu.createButton(
    currentButtonY,
    false,
    't_bet',
    'Blank.png',
    settingsMenu.toggleStake
  );
  currentButtonY -= buttonYoffset;

  // Lobby button
  if (settingsMenu.buttons.btnHome === true) {
    settingsMenu.lobbyToggle = settingsMenu.createButton(
      currentButtonY,
      false,
      settingsMenu.toggleLobby,
      'Desktop_UI_Menu/Desktop_Home_Button.png'
    );
    currentButtonY -= buttonYoffset;
  }

  if (settingsMenu.buttons.btnHistory.visible) {
    // History toggle button
    settingsMenu.historyToggle = settingsMenu.createButton(
      currentButtonY,
      false,
      settingsMenu.toggleHistory,
      'Desktop_UI_Menu/Desktop_GameHistory_Button.png'
    );
    currentButtonY -= buttonYoffset;
  }

  if (settingsMenu.buttons.btnSettings.visible) {
    settingsMenu.optionsToggle = settingsMenu.createButton(
      currentButtonY,
      false,
      settingsMenu.toggleOptionsMenu,
      'Desktop_UI_Menu/Desktop_Settings_Button.png'
    );
    settingsMenu.optionsToggle.glow = resourceManager.createObject(
      'sprite',
      'closeCheckbox',
      settingsMenu.optionsToggle.button.Props.FQN,
      { x: -10, y: -10, fileName: 'Desktop_UI_Menu/Large_Button_Highlight.png' }
    );
    settingsMenu.optionsToggle.glow.visible = false;
    if (!shouldHideOptions) currentButtonY -= buttonYoffset;
  }

  if (settingsMenu.buttons.btnRules.visible) {
    // Rules toggle button
    settingsMenu.rulesToggle = settingsMenu.createButton(
      currentButtonY,
      false,
      settingsMenu.toggleRules,
      'Desktop_UI_Menu/Desktop_GameRules_Button.png'
    );
    currentButtonY -= buttonYoffset;
  }

  if (settingsMenu.buttons.btnInfo.visible) {
    settingsMenu.helpToggle = settingsMenu.createButton(
      currentButtonY,
      false,
      settingsMenu.toggleHelp,
      'Desktop_UI_Menu/Desktop_Info_Button.png'
    );
    currentButtonY -= buttonYoffset;
  }

  if (settingsMenu.buttons.btnFullscreen.visible) {
    settingsMenu.fullscreenToggle = settingsMenu.createButton(
      currentButtonY,
      false,
      settingsMenu.toggleFullScreen,
      'Desktop_UI_Menu/Desktop_FullScreen_Button.png'
    );
    currentButtonY -= buttonYoffset;
  }

  for (var i = 0; i < settingsMenu.toggles; ++i) {
    settingsMenu.toggles[i].checkbox.interactive = true;
    settingsMenu.toggles[i].check.interactive = true;
  }
  settingsMenu.reflect();

  if (shouldHideOptions) {
    resourceManager.get('settingsMenu:buttonsContainer:graphics3').visible = false;
  }
};

settingsMenu.createButton = function (y, enabled, interactiveCallback, file) {
  var index = settingsMenu.toggles.length;

  var toggle = {
    active: enabled,
    button: resourceManager.createObject('sprite', 'graphics' + index, settingsMenu.buttonsContainer.name, {
      fileName: file,
      x: 32,
      y: y,
    }),
    //text: resourceManager.createObject("text", "text"+index, settingsMenu.background.name, {x:280, y:y, "translationPhrase": translationPhrase, "fontDefinition": fontDefinition, "maxWidth": 400, maintainAspectRatio: false, "anchor": 0.5 })
  };

  var x = -25 * resourceManager.selectedAssetResolution.scale;
  var w = 460 * resourceManager.selectedAssetResolution.scale;
  var h = 70 * resourceManager.selectedAssetResolution.scale;
  var y = -h / 2;

  toggle.button.interactive = true;
  toggle.button.mousedown = toggle.button.touchstart = interactiveCallback;

  settingsMenu.toggles.push(toggle);
  return toggle;
};

settingsMenu.createToggle = function (y, enabled, translationPhrase, fontDefinition, interactiveCallback) {
  var index = settingsMenu.toggles.length;

  var toggle = {
    active: enabled,
    checkbox: resourceManager.createObject('sprite', 'checkbox' + index, settingsMenu.background.name, {
      x: 70,
      y: y,
      fileName: 'UserInterface/Settings_BlackSquare.png',
      anchor: 0.5,
    }),
    check: resourceManager.createObject('sprite', 'check' + index, settingsMenu.background.name, {
      x: 70,
      y: y,
      fileName: 'UserInterface/Settings_Tick.png',
      anchor: 0.5,
    }),
    text: resourceManager.createObject('text', 'text' + index, settingsMenu.background.name, {
      x: 120,
      y: y,
      translationPhrase: translationPhrase,
      fontDefinition: fontDefinition,
      maxWidth: 400,
      maintainAspectRatio: false,
      anchor: { x: 0, y: 0.5 },
    }),
  };

  toggle.check.setInteractiveCallbacks(interactiveCallback, true);
  toggle.checkbox.setInteractiveCallbacks(interactiveCallback, true);

  settingsMenu.toggles.push(toggle);

  return toggle;
};

settingsMenu.getFilesRequired = function (json) {
  var files = [];
  files.push(ReflexLoader.rootResDir + json.textureName);
  return files;
};

settingsMenu.showPopup = function () {
  resourceManager.get('buttonContainer:buttonBar:settingsMenu:glow').visible = true;
  settingsMenu.stakeToggle.button.interactive = !gdk.isPromotionActive();
  settingsMenu.stakeToggle.button.alpha = settingsMenu.stakeToggle.button.interactive ? 1 : 0.5; //gdk.isPromotionActive();
  //settingsMenu.stakeToggle.text.alpha = settingsMenu.stakeToggle.button.alpha ;
  settingsMenu.container.visible = true;
  settingsMenu.background.interactive = true;

  gameData.screenDim.setAlpha(0.7);
  gameData.screenDim.show();
  gameData.screenDim.interactive = true;
  gameData.screenDim.mousedown = gameData.screenDim.touchstart = settingsMenu.hidePopup;

  messageBus.post('game:modal', { reason: 'Settings menu open' });
};

settingsMenu.hidePopup = function () {
  resourceManager.get('buttonContainer:buttonBar:settingsMenu:glow').visible = false;
  soundManager.play('buttonPressed');

  settingsMenu.background.interactive = false;
  gameData.screenDim.show(false);
  gameData.screenDim.mousedown = gameData.screenDim.touchstart = function () {};
  gameData.screenDim.interactive = false;

  var systemSettingsBox = resourceManager.get('systemSettings:systemSettingsBox');
  systemSettingsBox.showsystemSettingsBoxPanel(false);

  settingsMenu.container.visible = false;

  messageBus.post('game:modal', {});
};

settingsMenu.toggleOptionsMenu = function () {
  var settingsBox = resourceManager.get('systemSettings:systemSettingsBox');
  settingsBox.showsystemSettingsBoxPanel(true);
  soundManager.play('buttonPressed');
};

settingsMenu.toggleHistory = function () {
  settingsMenu.buttons.cbHistory();
  settingsMenu.hidePopup();
};

settingsMenu.toggleRules = function () {
  let style = `<style>
                body {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    background: rgb(220,148,91);
                    background: linear-gradient(0deg, rgba(220,148,91,1) 0%, rgba(255,222,195,1) 72%, rgba(255,222,195,1) 100%);
                    text-align: center;
                }
                h1 {
                    color: #990000;
                }
                h3 {
                    color: #990000;
                }
                ul {
                    text-align: left;
                }
                p {
                    text-align: left;
                }
            </style>`;
  let gameRulestText = gdk.translateText('gameRules', []);
  htmlViewer.show(`${style}${gameRulestText}`, 't_settings_close', true);
  soundManager.play('buttonPressed');
};

settingsMenu.toggleFullScreen = function () {
  settingsMenu.fullscreenToggle.active = !settingsMenu.fullscreenToggle.active;
  if (!settingsMenu.fullScreenOn) {
    settingsMenu.fullScreenOn = true;
    gdk.requestFullscreen();
  } else {
    gdk.exitFullscreen();
    settingsMenu.fullScreenOn = false;
  }
  settingsMenu.reflect();
};

settingsMenu.toggleStake = function () {
  resourceManager.getController('stakeController').showPopup();
  settingsMenu.reflect();
  settingsMenu.hidePopup();
};

settingsMenu.toggleHelp = function () {
  settingsMenu.hidePopup();
  gameData.helpPageScroll.open();
};

settingsMenu.toggleLobby = function () {
  soundManager.play('buttonPressed');
  gdk.goHome();
  settingsMenu.reflect();
};

settingsMenu.toggleTurboMode = function () {
  soundManager.play('buttonPressed');
  settingsMenu.turboModeToggle.active = !settingsMenu.turboModeToggle.active;
  settingsMenu.reflect();
};

settingsMenu.toggleSound = function () {
  soundManager.play('buttonPressed');
  settingsMenu.soundToggle.active = !settingsMenu.soundToggle.active;
  settingsMenu.reflect();
};

settingsMenu.onFullScreenChanged = function (isFullscreen) {
  if (settingsMenu.buttons && settingsMenu.buttons.btnFullscreen && settingsMenu.buttons.btnFullscreen.visible) {
    settingsMenu.fullscreenToggle.active = isFullscreen;
    settingsMenu.reflect();
  }
};

settingsMenu.reflect = function () {
  if (settingsMenu.soundToggle !== undefined) {
    if (settingsMenu.soundToggle.check) {
      settingsMenu.soundToggle.check.visible = settingsMenu.soundToggle.active;
    }
    Howler.mute(!settingsMenu.soundToggle.active);
  }

  if (settingsMenu.turboModeToggle !== undefined && settingsMenu.turboModeToggle.check !== undefined) {
    settingsMenu.turboModeToggle.check.visible = settingsMenu.turboModeToggle.active;
    if (settingsMenu.turboModeToggle.active) {
      settingsMenu.turboModeToggle.check.visible = true;
    } else {
      settingsMenu.turboModeToggle.check.visible = false;
    }
    gameController.turboMode = settingsMenu.turboModeToggle.active;
  }

  if (settingsMenu.historyToggle !== undefined && settingsMenu.historyToggle.check !== undefined) {
    settingsMenu.historyToggle.check.visible = settingsMenu.historyToggle.active;
    if (settingsMenu.historyToggle.active) {
      settingsMenu.historyToggle.check.visible = true;
    } else {
      settingsMenu.historyToggle.check.visible = false;
    }
  }

  if (settingsMenu.rulesToggle !== undefined && settingsMenu.rulesToggle.check !== undefined) {
    settingsMenu.rulesToggle.check.visible = settingsMenu.rulesToggle.active;
    if (settingsMenu.rulesToggle.active) {
      settingsMenu.rulesToggle.check.visible = true;
    } else {
      settingsMenu.rulesToggle.check.visible = false;
    }
  }

  if (settingsMenu.fullscreenToggle !== undefined && settingsMenu.fullscreenToggle.check !== undefined) {
    settingsMenu.fullscreenToggle.check.visible = settingsMenu.fullscreenToggle.active;
    if (settingsMenu.fullscreenToggle.active) {
      settingsMenu.fullscreenToggle.check.visible = true;
    } else {
      settingsMenu.fullscreenToggle.check.visible = false;
    }
  }
};

settingsMenu.onAudioStateChanged = function (state) {
  settingsMenu.soundActive = !state.muted;

  if (settingsMenu.soundToggle) {
    settingsMenu.soundToggle.active = settingsMenu.soundActive;
    settingsMenu.reflect();
  }
};

settingsMenu.onModal = function (msg) {
  // is something takes us out of modal but we are still visible, keep modal
  // For example, history will cause Gati wrapper to pause our game and resume when history closed.
  // Resume will clear modal but this settings menu is still open allowing the player to spin behind the settings menu
  if (settingsMenu.container.visible && msg.reason === undefined) {
    messageBus.post('game:modal', { reason: 'Settings menu open' });
  }
};

settingsMenu.onOrientationChange = function () {
  if (resourceManager.get('buttonContainer:buttonBar:settingsMenu:glow') === undefined) {
    return;
  }
  if (settingsMenu.container.visible) {
    resourceManager.get('buttonContainer:buttonBar:settingsMenu:glow').visible = true;
  } else {
    resourceManager.get('buttonContainer:buttonBar:settingsMenu:glow').visible = false;
  }
};

//event listener to mute and un-mute the sound when you change tabs
document.addEventListener(
  'visibilitychange',
  function () {
    if (document.visibilityState === 'hidden') {
      Howler.mute(true);
    } else {
      settingsMenu.reflect();
    }
  },
  false
);

messageBus.subscribe('game:modal', settingsMenu.onModal);
messageBus.subscribe('audio:stateChanged', settingsMenu.onAudioStateChanged);
messageBus.subscribe('common:FullyLoaded', settingsMenu.setup);
messageBus.subscribe('spinner:GameConfigEvent', settingsMenu.onConfig);
Reflex.registerEventHandler('fullScreen', settingsMenu.onFullScreenChanged);
Reflex.registerEventHandler('orientationChange', settingsMenu.onOrientationChange);
resourceManager.registerObjectType(
  'settingsMenu',
  settingsMenu.create,
  settingsMenu.initialise,
  settingsMenu.getFilesRequired
);
